import { StandardizedCompatibilityDisplay } from "./StandardizedCompatibilityDisplay";
import { WeightedCompatibilityResult } from "@/utils/weightedCompatibility";

interface WeightedCompatibilityScoreProps {
  result: WeightedCompatibilityResult;
  showDetails?: boolean;
  profile1Name?: string;
  profile2Name?: string;
}

export function WeightedCompatibilityScore({ result, showDetails = true, profile1Name, profile2Name }: WeightedCompatibilityScoreProps) {
  return (
    <StandardizedCompatibilityDisplay
      result={result}
      showDetails={showDetails}
      profile1Name={profile1Name}
      profile2Name={profile2Name}
    />
  );
}
